<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Approche directe" subTitle="" srcImg="/images/pages/recrutement/desc-picture.png"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="approche-directe" breadcrumb1="" breadcrumb2="Approche directe" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - Accompagnement en recrutement par approche directe",
  meta: [
    {
      name: "description",
      content: "Notre équipe d'experts EMCI vous accompagne dans le recrutement par approche directe. Opter pour un cabinet de chasseur de tête pour vos besoins de recrutement "
    }
  ]
})
</script>

<style scoped>
.body {

  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>